var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._l((_vm.fields),function(field,idx){return [_c('Cell',{key:idx,attrs:{"item":_vm.item,"field":field,"onClickRow":_vm.onClickRow},on:{"reloadTable":_vm.reloadTable}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }